import type { PDFDocumentProxy } from '../../lib/pdfWorker';
import type { PageFieldInfo, ViewerMode } from './signingTypes';
import ThumbnailPage from './ThumbnailPage';
import { PDF_VIEWER } from './pdfViewerTokens';
import { APP } from '../app/tokens';

interface ThumbnailRailProps {
  document: PDFDocumentProxy;
  numPages: number;
  pageFieldIndex: PageFieldInfo[];
  mode: ViewerMode;
  activePage: number;
  onPageClick: (page: number) => void;
}

export default function ThumbnailRail({ document, numPages, pageFieldIndex, mode, activePage, onPageClick }: ThumbnailRailProps) {
  return (
    <div style={{
      width: PDF_VIEWER.railWidth,
      flexShrink: 0,
      overflowY: 'auto',
      padding: PDF_VIEWER.railPadding,
      display: 'flex',
      flexDirection: 'column',
      gap: 8,
      borderLeft: `1px solid ${APP.border}`,
      backgroundColor: APP.bgSidebar,
    }}>
      <div style={{ fontSize: 10, fontWeight: 600, color: APP.textMuted, textTransform: 'uppercase', letterSpacing: '0.05em', padding: '0 2px 4px', flexShrink: 0 }}>
        Pages
      </div>
      {Array.from({ length: numPages }, (_, idx) => idx + 1).map((page) => {
        const info = pageFieldIndex[page - 1];
        const signerFields = info?.fieldsForCurrentSigner ?? [];
        const total = mode === 'configure' ? (info?.allFields.length ?? 0) : signerFields.length;
        const completed = mode === 'configure' ? 0 : signerFields.filter((f) => f.signed).length;
        return (
          <ThumbnailPage
            key={page}
            document={document}
            pageNumber={page}
            isActive={page === activePage}
            fieldCount={total}
            completedCount={completed}
            mode={mode}
            onPageClick={onPageClick}
          />
        );
      })}
    </div>
  );
}
